export const findWorkspaceSpecialty = ({ specialty, workspace }) => {
    return specialty?.config?.find((nextSpecialtyObj) => nextSpecialtyObj?.workspace?.toLowerCase() === workspace?.id?.toLowerCase());
};
